export enum GameType {
  MultipleChoice = 'MultipleChoice',
  DragDropIntoBuckets = 'DragDropIntoBuckets',
  DragDropIntoSentences = 'DragDropIntoSentences',
  UncontrolledSpelling = 'UncontrolledSpelling',
  UncontrolledSpellingWordLadders = 'UncontrolledSpellingWordLadders',
  ControlledSpellingWordLadders = 'ControlledSpellingWordLadders',
  ControlledSpelling1 = 'ControlledSpelling1',
  ControlledSpelling2 = 'ControlledSpelling2',
  ControlledSpelling3 = 'ControlledSpelling3',
  ControlledSpelling4 = 'ControlledSpelling4',
  TextEvidence = 'TextEvidence',
}
